module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a4wnM"))).then(() => module.bundle.root('d0iPb'));